import {axiosGet, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatCurrency, numberFormatter} from "../../../common/Helper/Support/SettingsHelper";
import {ucFirst} from "../../../common/Helper/Support/TextHelper";
import {DepartmentFilterMixin} from "./FilterMixin";

export default {
    mixins: [DepartmentFilterMixin, DatatableHelperMixin],
    data() {
        return {
            urlGenerator,
            options: {
                name             : this.$t('payroll'),
                url              : `${TENANT_BASE_URL}app/salary-sheet`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('employee'),
                        type     : 'custom-html',
                        key      : 'employee',
                        isVisible: true,
                        tdClassName: 'employee-id-column',
                        modifier : (data) => {
                            return data.profile.employee_id + ' ' + data.full_name;
                        }
                    },
                    {
                        title    : this.$t('payrun_period'),
                        type     : 'custom-html',
                        key      : 'employee',
                        isVisible: true,
                        modifier : (data) => {
                            if (data.salary_type) {
                                return ucFirst(data.salary_type);
                            }
                            return '--';
                        }
                    },
                    {
                        title    : this.$t('month'),
                        type     : 'text',
                        key      : 'month',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('base_salary'),
                        type     : 'custom-html',
                        key      : 'base_salary',
                        isVisible: true,
                        modifier : (value) => {
                            return formatCurrency(numberFormatter(Number(value)));
                        }
                    },
                    {
                        title    : this.$t('allowance'),
                        type     : 'custom-html',
                        key      : 'totalAllowances',
                        isVisible: true,
                        modifier : (value) => {
                            return formatCurrency(numberFormatter(Number(value)));
                        }
                    },
                    {
                        title    : this.$t('deduction'),
                        type     : 'custom-html',
                        key      : 'totalDeductions',
                        isVisible: true,
                        modifier : (value) => {
                            return formatCurrency(numberFormatter(Number(value)));
                        }
                    },
                    {
                        title    : this.$t('net_salary'),
                        type     : 'custom-html',
                        key      : 'net_salary',
                        isVisible: true,
                        modifier : (value) => {
                            return formatCurrency(numberFormatter(Number(value)));
                        }
                    },
                    {
                        title    : this.$t('attachment'),
                        type     : 'custom-html',
                        key      : 'attachment',
                        isVisible: true,
                        modifier : (value) => value ? `<a href="${urlGenerator(value)}" target="_blank">${this.$t('download')}</a>` : '--'
                    },
                    {
                        title    : this.$t('confirmed'),
                        type     : 'custom-html',
                        key      : 'receipt',
                        isVisible: true,
                        modifier : (value) => {
                            return value && value.id ? this.$t('yes') : this.$t('no');
                        }
                    },
                    {
                        title    : this.$t('payment_date'),
                        type     : 'custom-html',
                        key      : 'receipt',
                        isVisible: true,
                        modifier : (value) => {
                            if (!value) {
                                return ''
                            }
                            return value.payment_date;
                        }
                    },
                    {
                        title    : this.$t('payment_method'),
                        type     : 'custom-html',
                        key      : 'receipt',
                        isVisible: true,
                        modifier : (value) => {
                            if (!value) {
                                return ''
                            }
                            return this.$t(value.payment_method);
                        }
                    },
                    {
                        title    : this.$t('authorization'),
                        type     : 'custom-html',
                        key      : 'receipt',
                        isVisible: true,
                        modifier : (value) => {
                            if (!value) {
                                return ''
                            }
                            return value && value.authorization ? this.$t('yes') : this.$t('no');
                        }
                    },
                    {
                        title        : this.$t('public'),
                        type         : 'component',
                        key          : 'status',
                        isVisible    : true,
                        componentName: 'app-salary-sheet-confirmed',
                    },
                    // {
                    //     title     : this.$t('details'),
                    //     type      : 'button',
                    //     className : 'btn btn-secondary d-inline-flex align-items-center',
                    //     icon      : 'eye',
                    //     actionName: 'view',
                    //     modifier  : (row) => {
                    //         return 'View';
                    //     }
                    // },
                ],
                filters          : [
                    {
                        title         : this.$t('department'),
                        type          : "multi-select-filter",
                        key           : "departments",
                        option        : [],
                        listValueField: 'name',
                        permission    : this.$can('view_departments')
                    },
                    {
                        title         : this.$t('employee'),
                        type          : "multi-select-filter",
                        key           : "user_id",
                        option        : [],
                        listValueField: 'employee_name',
                    },
                    {
                        title         : this.$t('month'),
                        type          : "month-filter",
                        key           : "month",
                    },

                    {
                        title         : this.$t('status'),
                        type          : "drop-down-filter",
                        key           : "status",
                        option        : [
                            {
                                id  : 0,
                                name: this.$t('no'),
                            },
                            {
                                id  : 1,
                                name: this.$t('yes'),
                            },
                        ],
                        listValueField: 'name'
                    },
                    {
                        title         : this.$t('confirmed'),
                        type          : "drop-down-filter",
                        key           : "confirmed",
                        option        : [
                            {
                                id  : 0,
                                name: this.$t('no'),
                            },
                            {
                                id  : 1,
                                name: this.$t('yes'),
                            },
                        ],
                        listValueField: 'name'
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'dropdown',
                actions          : [
                    {
                        title     : this.$t('edit'),
                        type      : 'modal',
                        actionName: 'edit',
                        icon      : 'edit',
                        modifier  : row => this.$can('send_bulk_payslip')
                    },
                    {
                        title     : this.$t('view'),
                        type      : 'modal',
                        actionName: 'view',
                        icon      : 'eye',
                        modifier  : row => this.$can('send_bulk_payslip')
                    },
                    {
                        title     : this.$t('confirm'),
                        actionName: 'confirm',
                        icon      : 'check-circle',
                        modifier  : row => this.$can('view_payslip_pdf')
                    },
                    {
                        title     : this.$t('payment'),
                        actionName: 'payment',
                        icon      : 'credit-card',
                        modifier  : row => this.$can('send_bulk_payslip')
                    },
                    {
                        title     : this.$t('delete'),
                        type      : 'modal',
                        component : 'app-confirmation-modal',
                        modalId   : 'app-confirmation-modal',
                        url       : `${TENANT_BASE_URL}app/salary-sheet/`,
                        name      : 'delete',
                        actionName: 'delete',
                        icon      : 'trash-2',
                        modifier  : row => this.$can('send_bulk_payslip')
                    }
                ],
            }
        }
    },
    mounted() {
        this.getFilterValues()
    },
    methods: {
        getFilterValues() {
            const Error       = error => this.$toastr.e(error.response.data.message)
            const userFilter  = this.options.filters.find(item => item.key === 'user_id');
            const monthFilter = this.options.filters.find(item => item.key === 'month');

            axiosGet(`${this.apiUrl.COMMON}/get-months`)
                .then(({data}) => {
                    monthFilter.option = data
                })
                .catch(Error)
            axiosGet(`${this.apiUrl.TENANT_SELECTABLE_USER}?without=admin&employee=only&with_auth=yes`)
                .then(({data}) => {
                    userFilter.option = data.map(user => ({
                        ...user,
                        employee_name: user?.profile?.employee_id
                            ? `${user.profile.employee_id} (${user.full_name})`
                            : user.full_name
                    }));
                })
                .catch(Error)
        },
    },
}
